import * as types from './actionTypes';
import { beginAjaxCall, ajaxCallError } from './ajaxStatusActions';
import axios from 'axios';
import { baseApi } from '../constants/app';

export function loadPayPeriodsSuccess(payPeriods) {
  return { type: types.LOAD_PAY_PERIODS_SUCCESS, payPeriods };
}

export function createPayPeriodSuccess(payPeriod) {
  return { type: types.CREATE_PAY_PERIOD_SUCCESS, payPeriod };
}

export function updatePayPeriodSuccess(payPeriod) {
  return { type: types.UPDATE_PAY_PERIOD_SUCCESS, payPeriod };
}

export function deletePayPeriodSuccess(payPeriod) {
  return { type: types.DELETE_PAY_PERIOD_SUCCESS, payPeriod };
}

export function loadPayPeriods() {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    let url = baseApi + 'pay-periods';
    return axios
      .get(url)
      .then((response) => {
        dispatch(loadPayPeriodsSuccess(response.data));
      })
      .catch((error) => {
        dispatch(ajaxCallError(error));
        throw error;
      });
  };
}

export function savePayPeriod(payPeriod) {
  return function (dispatch, getState) {
    dispatch(beginAjaxCall());
    let url = baseApi + 'pay-periods';
    if (payPeriod.id) {
      url = baseApi + 'pay-periods/' + payPeriod.id;
      return axios
        .put(url, {
          ...payPeriod,
        })
        .then((response) => {
          dispatch(updatePayPeriodSuccess(response.data));
        })
        .catch((error) => {
          dispatch(ajaxCallError(error));
          throw error;
        });
    } else {
      return axios
        .post(url, {
          startDate: payPeriod.startDate,
          endDate: payPeriod.startDate,
        })
        .then((response) => {
          dispatch(createPayPeriodSuccess(response.data));
        })
        .catch((error) => {
          dispatch(ajaxCallError(error));
          throw error;
        });
    }
  };
}

export function deletePayPeriod(payPeriod) {
  return function (dispatch) {
    let url = baseApi + 'pay-periods/' + payPeriod.id;
    return axios
      .delete(url)
      .then((response) => {
        dispatch(deletePayPeriodSuccess(response.data));
      })
      .catch((error) => {
        dispatch(ajaxCallError(error));
        throw error;
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/payPeriodActions.js